import { createAction } from 'redux-actions'

import * as constants from './constants'

export const fetchSavedReplies = createAction(constants.FETCH_SAVED_REPLIES)
export const fetchSavedRepliesPending = createAction(constants.FETCH_SAVED_REPLIES_PENDING)
export const fetchSavedRepliesSuccess = createAction(constants.FETCH_SAVED_REPLIES_SUCCESS)
export const fetchSavedRepliesFailure = createAction(constants.FETCH_SAVED_REPLIES_FAILURE)

export const updateSavedReply = createAction(constants.UPDATE_SAVED_REPLY)
export const updateSavedReplyPending = createAction(constants.UPDATE_SAVED_REPLY_PENDING)
export const updateSavedReplySuccess = createAction(constants.UPDATE_SAVED_REPLY_SUCCESS)
export const updateSavedReplyFailure = createAction(constants.UPDATE_SAVED_REPLY_FAILURE)

export const selectSavedReply = createAction(constants.SELECT_SAVED_REPLY)
export const clearSelectedSavedReply = createAction(constants.CLEAR_SELECTED_SAVED_REPLY)

export const setComposerTextToInsert = createAction(constants.SET_COMPOSER_TEXT_TO_INSERT)
export const clearComposerTextToInsert = createAction(constants.CLEAR_COMPOSER_TEXT_TO_INSERT)



// WEBPACK FOOTER //
// ./src/scripts/app/modules/composer/actions.js